<div class="sender flex pointer">
  <app-player-row
    (click)="contextMenuService.open($event, { user: message() })"
    [player]="message()"
  ></app-player-row>
  @if ((message().role ?? 0) > 0) {
  <div class="admin rounded-4 padding-x-6 h-20 button--style-primary">
    {{ ADMIN_LEVELS[(message().role ?? 0) - 1] }}
  </div>
  }
  <!--  -->
  <div class="message-buttons flex items-center">
    @for (badge of messageFeatureBadges(); track $index) {
    <div
      class="button rounded-4 h-26 padding-x-4 button--style-white-04 message-button cursor-default"
    >
      {{ badge.title }}
    </div>
    } @if (sessionService.is_admin()) {
    <button
      class="button rounded-4 h-26 padding-x-4 button--style-white-04 message-button"
      (click)="clipboardService.copy(message().steamid, 'SteamID copied')"
    >
      Copy SteamID
    </button>
    }
  </div>
</div>
<p
  class="content"
  [innerHTML]="message().response | chatEmote : message().level"
></p>
